import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/payoffs';

class payoffService {
    /**
     * Tworzy nowego kierowcę, wysyłając dane kierowcy do endpointu.
     * 
     * @param {Object} payoff - Obiekt zawierający dane nowego kierowcy.
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera po pomyślnym utworzeniu kierowcy.
     */
    createPayoff(payoff) {
        return axios.post(API_URL, payoff);
    }

    /**
     * Pobiera listę wszystkich kierowców.
     * 
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera zawierającą listę wszystkich kierowców.
     */
    getAllPayoffs() {
        return axios.get(API_URL);
    }

    /**
     * Pobiera dane kierowcy na podstawie jego identyfikatora (ID).
     * 
     * @param {number|string} id - ID kierowcy, którego chcemy pobrać.
     * @returns {Promise<Object>} Zwraca dane kierowcy o podanym ID.
     */
    getPayoffById(id) {
        return axios.get(`${API_URL}/${id}`);
    }

    getPayoffByDriverId(id) {
        return axios.get(`${API_URL}/${id}/driver`);
    }

    /**
     * Aktualizuje dane kierowcy na podstawie jego identyfikatora (ID).
     * 
     * @param {number|string} id - ID kierowcy, którego chcemy zaktualizować.
     * @param {Object} updatedPayoff - Obiekt zawierający zaktualizowane dane kierowcy.
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera po pomyślnej aktualizacji danych kierowcy.
     */
    updatePayoff(id, updatedPayoff) {
        return axios.put(`${API_URL}/${id}`, updatedPayoff);
    }

    /**
     * Usuwa kierowcę na podstawie jego identyfikatora (ID).
     * 
     * @param {number|string} id - ID kierowcy, którego chcemy usunąć.
     * @returns {Promise<void>} Zwraca odpowiedź z serwera po pomyślnym usunięciu kierowcy.
     */
    deletePayoff(id) {
        return axios.delete(`${API_URL}/${id}`);
    }
}

export default new payoffService();
